import request from "@src/utils/request";

export interface ManualClinicPayload {
  clinicName: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postalCode: string;
  phone: string;
}

export function setDefaultClinic(clinicId: string) {
  return request()
    .post("/api/v1/current-user/set-default-clinic/")
    .send({ clinicId });
}

export function addClinicManual(payload: ManualClinicPayload) {
  return request()
    .post("/api/v1/current-user/add-clinic-manual/")
    .send(payload);
}

export function updateClinic(
  clinicId: string,
  payload: Partial<ManualClinicPayload>,
) {
  return request().patch(`/api/v1/clinics/${clinicId}/`).send(payload);
}

export function removeClinic(clinicId: string) {
  return request().delete(`/api/v1/current-user/clinics/${clinicId}/`).send();
}
